var _clipPath, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1102 288",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 1101.77,
    height: 287.746,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard11",
    serifId: "Artboard1",
    x: 0,
    y: 0,
    width: 1101.77,
    height: 287.746
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Black-Sticker",
    serifId: "Black Sticker",
    x: 0,
    y: 0,
    width: 1329,
    height: 633,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Black-Sticker1",
    serifId: "Black Sticker",
    transform: "matrix(1,0,0,1,-118.145,-168.919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1153.95,239.198L1115.16,239.198L1083.75,272.664L1044.58,272.664L871.885,456.665L427.06,456.629L357.923,383.098L373.896,348.502L302.743,272.664L254.292,272.664L222.881,239.198L184.109,239.198L118.145,168.919L1219.91,168.919C1197.92,192.345 1175.94,215.772 1153.95,239.198Z",
    style: {
      fill: "white"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "outline",
    d: "M1148.97,227.698L1110.18,227.698L1078.77,261.164L1039.6,261.164L866.907,445.164L432.033,445.13L371.617,380.874L387.586,346.286L307.722,261.164L259.27,261.164L227.859,227.698L189.087,227.698L144.711,180.419L1193.35,180.419L1148.97,227.698Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Letters"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1143.99,216.198L508.923,216.198L489.252,258.838L478.04,283.123L438.287,369.295L405.667,334.54L429.388,283.123L440.6,258.838L460.271,216.198L194.065,216.198L171.277,191.919L1166.78,191.919L1143.99,216.198Z",
    style: {
      fill: "rgb(204,19,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.46,225.385L1096.58,225.385L1073.79,249.664L552.816,249.664L548.474,258.838L536.994,283.123L465.798,433.624L436.91,433.623L385.309,378.652L401.284,344.052L440.683,386.03L503.62,249.664L264.248,249.664L241.46,225.385Z",
    style: {
      fill: "rgb(48,106,191)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "White-Line",
    serifId: "White Line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.473,258.838L419.274,283.123L344.094,283.123L321.309,258.838L430.473,258.838Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.98,258.838L1003.2,283.123L547.143,283.123L558.636,258.838L1025.98,258.838Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "UAV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M619.525,401.744L632.082,377.398L642.364,377.398L619.525,401.744ZM650.969,368.224L636.813,368.224L641.544,359.05L659.575,359.05L650.969,368.224ZM668.181,349.876L646.276,349.876L651.007,340.702L676.787,340.702L668.181,349.876ZM685.393,331.528L655.739,331.528L660.47,322.354L693.998,322.354L685.393,331.528ZM702.604,313.18L665.201,313.18L669.933,304.006L711.21,304.006L702.604,313.18Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.316,376.749C745.618,371.853 746.069,364.434 746.503,356.997C740.773,363.703 733.433,370.313 727.963,376.749L745.316,376.749ZM742.379,433.644L743.411,409.76L697.353,409.363L677.038,431.008L674.577,433.63L628.564,433.621L750.217,304.006L796.238,304.006L794.951,433.653L742.379,433.644Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.918,433.664L835.713,304.006L885.004,304.006L881.876,359.812L930.289,304.006L983.621,304.006L861.929,433.664L833.918,433.664Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.152,304.006L577.44,312.531L576.751,314.112C570.313,328.868 563.765,343.6 557.149,358.309C554.975,363.137 552.643,367.899 550.777,372.797C550.328,373.973 549.91,375.16 549.531,376.36C547.938,381.416 546.099,387.846 549.458,392.643C551.766,395.939 556.292,396.654 560.456,396.709C578.627,396.947 591.992,381.344 599.547,364.788C608.162,345.751 618.29,323.147 626.691,304.006L669.933,304.006C661.898,322.33 652.229,343.885 644.048,361.93C641.35,367.876 638.779,373.887 635.912,379.733C631.853,388.01 625.831,395.096 619.525,401.744C600.325,421.989 572.879,434.408 544.905,433.626C528.227,433.16 510.08,427.35 503.38,413.056C497.534,400.584 501.122,386.607 506.797,374.262C516.177,354.041 525.805,333.963 535.385,313.835L540.066,304.006L581.152,304.006Z",
    style: {
      fill: "white"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8e71c6ed504e6c6683b9c8c71ec3fe86.svg";
export { ForwardRef as ReactComponent };